import { ScheduleAvailabilityParams } from "@/domain/dtos/params";
import { z } from "zod";

export const ScheduleAvailabilityParamsSchema: z.ZodType<ScheduleAvailabilityParams> =
  z.object({
    user_id: z.union([z.number().int().positive(), z.undefined()]),
    date: z.string().optional(),
  });
